<div class="prompt-container">
  <textarea
    class="prompt-input"
    [(ngModel)]="prompt"
    placeholder="Describe what to change..."
    rows="3"
    (keydown.enter)="$event.preventDefault(); submit()"
  ></textarea>
  <button
    class="prompt-submit"
    [disabled]="isLoading || !prompt.trim()"
    (click)="submit()"
  >
    <nw-icon *ngIf="!isLoading" type="arrow_upward" [size]="16" color="white"></nw-icon>
    <nw-icon *ngIf="isLoading" type="hourglass_top" [size]="16" color="white"></nw-icon>
  </button>
</div>
